export const NOTIFICATION_LIST = 'NOTIFICATION_LIST'
export const NOTIFICATION_COUNT = 'NOTIFICATION_COUNT'